import { useTheme } from "@mui/material/styles";

const HashIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.36661 0.700195L3.36661 12.7002M10.6999 0.700195L8.69993 12.7002M12.7 4.03353H1.36662M12.0333 9.36686H0.699951"
        stroke={theme.palette.otherTextTertiary.main}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HashIcon;
